/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { defineStore } from 'pinia';
import { qryUserQual, exchActPrizeInfo, exchangePrize, ExchangePrizeType, QryUserQualQueryType } from '@tencent/wphk-act-base-cgi';
import { CONF, EXPIREDCONF, getAllExpiredActId, getMultiLangAttr } from '@/business/act-config';
import { useConfigStore } from './config';
import dayjs from 'dayjs';

import { getActJoinedInfo } from '@/lib/act-query';
import { GoodDeedDayNGOType, NGOInfo } from '@/types';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import { getWeekDate } from '@tencent/wphk-components-common/utils/time';

import { getExchActList } from '@/business/past';
import { PastItemType } from '@/types/past';

import { language } from '@tencent/ppd-base-libs';

// 默认头像
const defaultAvatar = 'https://st.moneydata.hk/res/fmd_mojo_static/whdA2wj6rMyOxmni33oFMog4KkvJSlZR.png';

export const useStampStore = defineStore('stamp', {
  state: () => ({
    // 个人印花信息
    userStampInfo: {
      // 用户已捐贈总印花数
      usedCnt: 0,
      // 用户当天获得印花数
      intervalTotalCnt: 0,
      // 用户当天使用印花数
      intervalUsedCnt: 0,
      // 用户可使用印花数
      intervalAvailableCnt: 0,
      // 用户昵称
      nickName: '',
      // 用户头像
      faceUrl: '',
    },
    // 总活动信息
    globalActInfo: {
      // 活动累计捐贈印花数
      totalSendNum: 0,
      // 季度限额
      totalLimit: 0,
      // 活动当日捐贈印花数
      daySent: 0,
      // 活动当日捐贈日限额 15000
      dayLimit: 0,
      // 活动 id 加密串
      enActid: '',
      // 密文兑换活动奖品id
      prizeId: '',
    },
    // 当前ngo信息
    currentNGO: {
      // 今日已累计捐赠次数
      userTodayDonatedCount: 0,
    },
    // NGO 活动信息
    ngoActInfoList: [] as Array<NGOInfo & GoodDeedDayNGOType>,

    donationNGO: { enName: '', name: '' },

    // 往期活动活动信息
    pastList: [] as Array<PastItemType>,
  }),
  getters: {
    expiredNgoActInfoList: (state) => {
      const allList = state.pastList.map(item => (item.ngoList));
      return allList.flat();
    },
  },
  actions: {
    /**
     * 查询用户印花信息
     */
    async qryUserQual() {
      try {
        const weekDate = getWeekDate(getServerTime());
        const data = await qryUserQual({
          qualId: CONF.stampId, startTime: weekDate.startTime, endTime: weekDate.endTime,
          qryAllInfo: QryUserQualQueryType.querySum,
        });
        this.userStampInfo = {
          usedCnt: data.allUsedCnt || 0,
          intervalTotalCnt: data.intervalTotalCnt || 0,
          intervalUsedCnt: data.intervalUsedCnt || 0,
          intervalAvailableCnt: (data.intervalTotalCnt || 0) - (data.intervalUsedCnt || 0),
          nickName: data.nickName || '',
          faceUrl: data.faceUrl || defaultAvatar,
        };
      } catch (error) {
        throw error;
      }
    },
    /**
     * 查询总活动信息
     */
    // export const EXCH_ACT_PRIZE_INFO = '/app/task/exch_act_prize_info.cgi';
    async exchActPrizeInfoForGlobal() {
      try {
        const data = await exchActPrizeInfo({ exchActidList: CONF.globalActId, qryQualAct: 1, statUserCpn: 1 });
        const list = data.exchActidList || [];
        const act = list[0];
        if (act) {
          this.globalActInfo = {
            totalSendNum: 0,
            totalLimit: CONF.targetNum,
            daySent: act.daySent || 0,
            dayLimit: act.dayLimit || 0,
            enActid: act.enActid || '',
            prizeId: act.prizeId || '',
          };
        }
      } catch (error) {
        throw error;
      }
    },
    /**
     * 查询 ngo 活动信息
     */
    async exchActPrizeInfoForNGO() {
      try {
        const configStore = useConfigStore();
        const configOnline = configStore.goodDeedDayNGO; // 配置中心 ngo 配置

        // 接口查询三个活动信息
        const data = await exchActPrizeInfo({ qualIdList: CONF.stampId, qryQualAct: 1, statUserCpn: 1 });
        const list = data.qualExchActidList || [];

        // 查询用户对三个活动的兑换情况
        const actJoinedList = await this.getActJoinedList();

        // 权重数组
        const orderArr: number[] = [];
        let totalSendNum = 0;
        let ngoActInfoList = list.map((ngoAct) => {
          // 接口信息 -> enActid -> 本地配置 -> key -> 线上配置
          const ngoInfo = CONF.actList.find((act) => act.enActid === ngoAct.enActid);
          let ngoConf: GoodDeedDayNGOType = {
            key: '',
            name: '',
            enName: '',
            desc: '',
            descEn: '',
            contact: '',
            content: '',
            pic: '',
            logo: '',
            order: '',
            sharepic: '',
          };

          if (ngoInfo) {
            ngoConf = configOnline[ngoInfo.key];
            totalSendNum = totalSendNum + (ngoAct.totalSendNum || 0);
          }

          // 接口信息 -> prizeId -> 本地配置 -> qualId -> 接口信息
          const actJoinedInfo = actJoinedList.find((act) => act.qualId === ngoAct.prizeId);

          orderArr.push(parseInt(ngoConf.order, 10));
          if (ngoConf.name === sessionStorage.getItem('currentNGOName')) {
            console.log('--------------------currentNGOName', sessionStorage.getItem('currentNGOName'));
            this.currentNGO.userTodayDonatedCount = actJoinedInfo?.intervalTotalCnt || 0;
          }

          return {
            totalSendNum: ngoAct.totalSendNum,
            daySent: ngoAct.daySent || 0,
            dayLimit: ngoAct.dayLimit || 99999999,
            enActid: ngoAct.enActid || '',
            prizeId: ngoAct.prizeId || '',
            hasGot: actJoinedInfo?.totalCnt || 0, // 用户对每个活动的捐贈数
            donateCount: 1,
            userTodayDonatedCount: actJoinedInfo?.intervalTotalCnt || 0,
            ...ngoConf,
          };
        });
        ngoActInfoList = ngoActInfoList.filter(item => item.key);
        this.globalActInfo.totalSendNum = totalSendNum;
        // 列出权重数组，判断是否都是相同的权重
        const isAllEqual = orderArr.every((val) => val === orderArr[0]);
        if (isAllEqual) {
          // 权重相同则随机排序
          ngoActInfoList = ngoActInfoList.sort(() => Math.random() - 0.5);
        } else {
          // 权重不同则按照权重排序
          ngoActInfoList = ngoActInfoList.sort((a, b) => parseInt(a.order, 10) - parseInt(b.order, 10));
        }
        this.ngoActInfoList = ngoActInfoList;
      } catch (error) {
        throw error;
      }
    },
    /**
     * 捐贈
     * @param enActid 商品发放活动id
     * @param prizeId 兑换的商品编号
     */
    async exchangePrize(enActid: string, prizeId: string) {
      return exchangePrize({
        qualId: CONF.stampId,
        actListid: enActid,
        prizeNo: prizeId,
        type: ExchangePrizeType.microsecond,
      });
    },
    /**
     * 查询用户对三个活动的兑换情况
     */
    async getActJoinedList() {
      const todayStartTime = new Date(dayjs().format('YYYY/MM/DD 00:00:00'));
      const todayEndTime = new Date(dayjs().format('YYYY/MM/DD 23:59:59'));
      const batchGetJoinInfoPromise = CONF.actList.map(async (act) => qryUserQual(
        { qualId: act.qualId,  startTime: todayStartTime, endTime: todayEndTime },
      ));
      const joinInfoResultList = await Promise.all(batchGetJoinInfoPromise);
      return joinInfoResultList;
    },

    /**
     * 查询用户活动参与状态
     * @returns
     */
    async qryUseractInfo() {
      // 获取当天起止时间戳(秒)
      const todayStartTime = new Date(dayjs().format('YYYY/MM/DD 00:00:00'));
      const todayEndTime = new Date(dayjs().format('YYYY/MM/DD 23:59:59'));

      const batchGetJoinInfoPromise = CONF.actList.map(async (act) => ({
        [act.enActid]: await getActJoinedInfo(act.enActid, undefined, 0, 10, todayStartTime, todayEndTime),
      }));
      const joinInfoResultList = await Promise.all(batchGetJoinInfoPromise);

      let obj = {};

      for (const actJoined of joinInfoResultList) {
        obj = Object.assign({}, obj, actJoined);
      }

      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const element = obj[key];
          if (element?.isCurDayJoined) {
            // 依赖 ngo 列表的返回
            this.donationNGO = this.ngoActInfoList.find((ele) => ele.enActid === key) || { enName: '', name: '' };
          }
        }
      }
    },
    async getPastData() {
      const configStore = useConfigStore();
      // 货源内的项目配置
      const configOnline = configStore.goodDeedDayNGO; // 配置中心 ngo 配置
      const pastExchActList = await getExchActList(getAllExpiredActId());
      const formatPastList = EXPIREDCONF.map(pastCfg => {
        const ngoItemList: Array<NGOInfo & GoodDeedDayNGOType> = pastCfg.actList.map((item) => {
          // 活动数据
          const ngoAct = pastExchActList.find(act => act.enActid === item.enActid)!;
          const ngoConf = configOnline[item.key];
          return {
            totalSendNum: ngoAct.totalSendNum,
            daySent: ngoAct.daySent || 0,
            dayLimit: ngoAct.dayLimit || 99999999,
            enActid: ngoAct.enActid || '',
            prizeId: ngoAct.prizeId || '',
            hasGot: 0, // 用户对每个活动的捐贈数
            donateCount: 1,
            userTodayDonatedCount: 0,
            ...ngoConf,
          };
        });
        // 排序
        const sortNgoList = ngoItemList.sort((a, b) => (+b.order - +a.order));
        return {
          startDate: pastCfg.startDate,
          endDate: pastCfg.endDate,
          title: getMultiLangAttr(pastCfg, 'project_title'),
          ngoList: sortNgoList,
        };
      });

      this.pastList = formatPastList;
    },
  },
});
